import { Component, Story, Knobs, Accents } from './DocTypes';

const PlaygroundStoryKnobs: Knobs = {
  type: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'underline', 'block', 'pills'],
    delimiter: '\n  ',
  },
  accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
    delimiter: '\n  ',
  },
  orientation: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'horizontal', 'vertical'],
    delimiter: '\n  ',
  },
  size: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'default', 'large', 'small'],
    delimiter: '\n  ',
  },
  selectedTab: {
    editor: 'dropdown',
    editorOptions: ['', 'tab1', 'tab2', 'tab3'],
    default: '',
    delimiter: '\n  ',
  },
  containerStyle: {
    editor: 'textbox',
    default: '',
    delimiter: '\n  ',
  },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const PlaygroundStoryKnobsReact: Knobs = {
  ...PlaygroundStoryKnobs,
  containerStyle: {
    ...PlaygroundStoryKnobs.containerStyle,
    qualifierStart: '{',
    qualifierEnd: '}',
  },
};

const PlaygroundStoryKnobsv1: Knobs = {
  accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
    delimiter: '\n  ',
  },
  size: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'default', 'large', 'small'],
    delimiter: '\n  ',
  },
  orientation: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'horizontal', 'vertical'],
    delimiter: '\n  ',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'Tab headers playground',
  coreComponent: {
    html: `<tag-tab-headers{{...knobs}}>
  <tag-tab-header name='tab1'>Tab 1</tag-tab-header>
  <tag-tab-header name='tab2'>Tab 2</tag-tab-header>
  <tag-tab-header name='tab3'>Tab 3</tag-tab-header>
</tag-tab-headers>`,
    knobs: PlaygroundStoryKnobsv1,
  },
  coreComponent_v3: {
    html: `<tag3-tab-headers{{...knobs}}>
  <tag3-tab-header name='tab1'>Tab 1</tag3-tab-header>
  <tag3-tab-header name='tab2'>Tab 2</tag3-tab-header>
  <tag3-tab-header name='tab3'>Tab 3</tag3-tab-header>
</tag3-tab-headers>`,
    knobs: PlaygroundStoryKnobs,
  },
  reactWrapper: {
    jsx: `<TagTabHeaders{{...knobs}}>
  <TagTabHeader name='tab1'>Tab 1</TagTabHeader>
  <TagTabHeader name='tab2'>Tab 2</TagTabHeader>
  <TagTabHeader name='tab3'>Tab 3</TagTabHeader>
</TagTabHeaders>`,
    knobs: PlaygroundStoryKnobsv1,
  },
  reactWrapper_v3: {
    jsx: `<Tag3TabHeaders{{...knobs}}>
  <Tag3TabHeader name='tab1'>Tab 1</Tag3TabHeader>
  <Tag3TabHeader name='tab2'>Tab 2</Tag3TabHeader>
  <Tag3TabHeader name='tab3'>Tab 3</Tag3TabHeader>
</Tag3TabHeaders>`,
    knobs: PlaygroundStoryKnobsReact,
  },
};

const OrientationKnob: Knobs = {
  orientation: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'horizontal', 'vertical'],
    delimiter: '\n  ',
  },
};

const SelectedTabStory: Story = {
  title: 'Selected tab',
  description: 'Tab headers with a tab selected by default',
  coreComponent: {
    html: `<tag-tab-headers
  selected-tab='tab2'{{...knobs}}>
  <tag-tab-header name='tab1'>Tab 1</tag-tab-header>
  <tag-tab-header name='tab2'>Tab 2</tag-tab-header>
  <tag-tab-header name='tab3'>Tab 3</tag-tab-header>
</tag-tab-headers>`,
    knobs: OrientationKnob,
  },
  coreComponent_v3: {
    html: `<tag3-tab-headers
  selected-tab='tab2'{{...knobs}}>
  <tag3-tab-header name='tab1'>Tab 1</tag3-tab-header>
  <tag3-tab-header name='tab2'>Tab 2</tag3-tab-header>
  <tag3-tab-header name='tab3'>Tab 3</tag3-tab-header>
</tag3-tab-headers>`,
    knobs: OrientationKnob,
  },
  reactWrapper: {
    jsx: `<TagTabHeaders
  selectedTab='tab2'{{...knobs}}>
  <TagTabHeader name='tab1'>Tab 1</TagTabHeader>
  <TagTabHeader name='tab2'>Tab 2</TagTabHeader>
  <TagTabHeader name='tab3'>Tab 3</TagTabHeader>
</TagTabHeaders>`,
    knobs: OrientationKnob,
  },
  reactWrapper_v3: {
    jsx: `<Tag3TabHeaders
  selectedTab='tab2'{{...knobs}}>
  <Tag3TabHeader name='tab1'>Tab 1</Tag3TabHeader>
  <Tag3TabHeader name='tab2'>Tab 2</Tag3TabHeader>
  <Tag3TabHeader name='tab3'>Tab 3</Tag3TabHeader>
</Tag3TabHeaders>`,
    knobs: OrientationKnob,
  },
};

const InvisibleTabStory: Story = {
  title: 'Invisible tab',
  description: 'Tab headers with tab 2 invisible',
  coreComponent: {
    html: `<tag-tab-headers{{...knobs}}>
  <tag-tab-header name='tab1'>Tab 1</tag-tab-header>
  <tag-tab-header name='tab2' invisible>Tab 2</tag-tab-header>
  <tag-tab-header name='tab3'>Tab 3</tag-tab-header>
</tag-tab-headers>`,
    knobs: OrientationKnob,
  },
  coreComponent_v3: {
    html: `<tag3-tab-headers{{...knobs}}>
  <tag3-tab-header name='tab1'>Tab 1</tag3-tab-header>
  <tag3-tab-header name='tab2' invisible>Tab 2</tag3-tab-header>
  <tag3-tab-header name='tab3'>Tab 3</tag3-tab-header>
</tag3-tab-headers>`,
    knobs: {
      ...OrientationKnob,
      type: {
        default: '',
        editor: 'dropdown',
        editorOptions: ['', 'underline', 'block', 'pills'],
        delimiter: '\n  ',
      },
    },
  },
  reactWrapper: {
    jsx: `<TagTabHeaders{{...knobs}}>
  <TagTabHeader name='tab1'>Tab 1</TagTabHeader>
  <TagTabHeader name='tab2' invisible>Tab 2</TagTabHeader>
  <TagTabHeader name='tab3'>Tab 3</TagTabHeader>
</TagTabHeaders>`,
    knobs: OrientationKnob,
  },
  reactWrapper_v3: {
    jsx: `<Tag3TabHeaders{{...knobs}}>
  <Tag3TabHeader name='tab1'>Tab 1</Tag3TabHeader>
  <Tag3TabHeader name='tab2' invisible>Tab 2</Tag3TabHeader>
  <Tag3TabHeader name='tab3'>Tab 3</Tag3TabHeader>
</Tag3TabHeaders>`,
    knobs: {
      ...OrientationKnob,
      type: {
        default: '',
        editor: 'dropdown',
        editorOptions: ['', 'underline', 'block', 'pills'],
        delimiter: '\n  ',
      },
    },
  },
};

const DisabledTabStory: Story = {
  title: 'Disable tab',
  description: 'Tab headers with tab 2 disabled',
  coreComponent: {
    html: `<tag-tab-headers{{...knobs}}>
  <tag-tab-header name='tab1'>Tab 1</tag-tab-header>
  <tag-tab-header name='tab2' disabled>Tab 2</tag-tab-header>
  <tag-tab-header name='tab3'>Tab 3</tag-tab-header>
</tag-tab-headers>`,
    knobs: OrientationKnob,
  },
  coreComponent_v3: {
    html: `<tag3-tab-headers{{...knobs}}>
  <tag3-tab-header name='tab1'>Tab 1</tag3-tab-header>
  <tag3-tab-header name='tab2' disabled>Tab 2</tag3-tab-header>
  <tag3-tab-header name='tab3'>Tab 3</tag3-tab-header>
</tag3-tab-headers>`,
    knobs: {
      ...OrientationKnob,
      type: {
        default: '',
        editor: 'dropdown',
        editorOptions: ['', 'underline', 'block', 'pills'],
        delimiter: '\n  ',
      },
    },
  },
  reactWrapper: {
    jsx: `<TagTabHeaders{{...knobs}}>
  <TagTabHeader name='tab1'>Tab 1</TagTabHeader>
  <TagTabHeader name='tab2' disabled>Tab 2</TagTabHeader>
  <TagTabHeader name='tab3'>Tab 3</TagTabHeader>
</TagTabHeaders>`,
    knobs: OrientationKnob,
  },
  reactWrapper_v3: {
    jsx: `<Tag3TabHeaders{{...knobs}}>
  <Tag3TabHeader name='tab1'>Tab 1</Tag3TabHeader>
  <Tag3TabHeader name='tab2' disabled>Tab 2</Tag3TabHeader>
  <Tag3TabHeader name='tab3'>Tab 3</Tag3TabHeader>
</Tag3TabHeaders>`,
    knobs: {
      ...OrientationKnob,
      type: {
        default: '',
        editor: 'dropdown',
        editorOptions: ['', 'underline', 'block', 'pills'],
        delimiter: '\n  ',
      },
    },
  },
};

const TabIconsStory: Story = {
  title: 'Tab Icons',
  description: 'Tab headers with icons',
  coreComponent: {
    html: `<tag-tab-headers>
  <tag-tab-header name='data'>
    <tag-icon icon='Database'></tag-icon>
    Data
  </tag-tab-header>
  <tag-tab-header name='settings'>
    <tag-icon icon='Settings'></tag-icon>
    Settings
  </tag-tab-header>
</tag-tab-headers>`,
  },
  coreComponent_v3: {
    html: `<tag3-tab-headers>
  <tag3-tab-header name='data'>
    <tag3-icon-svg icon='Database'></tag3-icon-svg>
    Data
  </tag3-tab-header>
  <tag3-tab-header name='settings'>
    <tag3-icon-svg icon='Settings'></tag3-icon-svg>
    Settings
  </tag3-tab-header>
</tag3-tab-headers>`,
  },
  reactWrapper: {
    jsx: `<TagTabHeaders>
  <TagTabHeader name='data'>
    <TagIcon icon='Database'></TagIcon>
    Data
  </TagTabHeader>
  <TagTabHeader name='settings'>
    <TagIcon icon='Settings'></TagIcon>
    Settings
  </TagTabHeader>
</TagTabHeaders>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3TabHeaders>
  <Tag3TabHeader name='data'>
    <Tag3IconSvg icon='Database'></Tag3IconSvg>
    Data
  </Tag3TabHeader>
  <Tag3TabHeader name='settings'>
    <Tag3IconSvg icon='Settings'></Tag3IconSvg>
    Settings
  </Tag3TabHeader>
</Tag3TabHeaders>`,
  },
};

const ControlledSelectedTabStory: Story = {
  title: 'Controlled selected tab',
  description: 'Tabs where the selected tab is controlled by React state',

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [selectedTab, setSelectedTab] = React.useState('tab2');
    return (
      <React.Fragment>
        <TagEditField
          label='Go to tab'
          editor='dropdown'
          options={[
            {label: 'Tab 1', value: 'tab1'},
            {label: 'Tab 2', value: 'tab2'},
            {label: 'Tab 3', value: 'tab3'},
          ]}
          value={selectedTab}
          onValueChange={e => setSelectedTab(e.detail.value)}
        />
        <TagTabHeaders
          selectedTab={selectedTab}
          onTabHeaderChange={e => setSelectedTab(e.detail.name)}>
          <TagTabHeader name='tab1'>Tab 1</TagTabHeader>
          <TagTabHeader name='tab2'>Tab 2</TagTabHeader>
          <TagTabHeader name='tab3'>Tab 3</TagTabHeader>
        </TagTabHeaders>
      </React.Fragment>
    )
  }`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [selectedTab, setSelectedTab] = React.useState('tab2');
    return (
      <React.Fragment>
        <TagEditField
          label='Go to tab'
          editor='dropdown'
          options={[
            {label: 'Tab 1', value: 'tab1'},
            {label: 'Tab 2', value: 'tab2'},
            {label: 'Tab 3', value: 'tab3'},
          ]}
          value={selectedTab}
          onValueChange={e => setSelectedTab(e.detail.value)}
        />
        <Tag3TabHeaders
          selectedTab={selectedTab}
          onTabHeaderChange={e => setSelectedTab(e.detail.name)}>
          <Tag3TabHeader name='tab1'>Tab 1</Tag3TabHeader>
          <Tag3TabHeader name='tab2'>Tab 2</Tag3TabHeader>
          <Tag3TabHeader name='tab3'>Tab 3</Tag3TabHeader>
        </Tag3TabHeaders>
      </React.Fragment>
    )
  }`,
  },
};

const OldSchoolTabsStoryKnobs: Knobs = {
  size: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'default', 'large', 'small'],
    delimiter: '\n  ',
  },
};
const OldSchoolTabsStory: Story = {
  title: 'Old school tabs',
  description: 'Old school tabs are back!',
  coreComponent: {
    html: `<tag-tab-headers type='block'{{...knobs}}>
  <tag-tab-header name='tab1'>Tab 1</tag-tab-header>
  <tag-tab-header name='tab2'>Tab 2</tag-tab-header>
  <tag-tab-header name='tab3'>Tab 3</tag-tab-header>
</tag-tab-headers>`,
    knobs: OldSchoolTabsStoryKnobs,
  },
  coreComponent_v3: {
    html: `<tag3-tab-headers type='block'{{...knobs}}>
  <tag3-tab-header name='tab1'>Tab 1</tag3-tab-header>
  <tag3-tab-header name='tab2'>Tab 2</tag3-tab-header>
  <tag3-tab-header name='tab3'>Tab 3</tag3-tab-header>
</tag3-tab-headers>`,
    knobs: OldSchoolTabsStoryKnobs,
  },
  reactWrapper: {
    jsx: `<TagTabHeaders type='block'{{...knobs}}>
  <TagTabHeader name='tab1'>Tab 1</TagTabHeader>
  <TagTabHeader name='tab2'>Tab 2</TagTabHeader>
  <TagTabHeader name='tab3'>Tab 3</TagTabHeader>
</TagTabHeaders>`,
    knobs: OldSchoolTabsStoryKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3TabHeaders type='block'{{...knobs}}>
  <Tag3TabHeader name='tab1'>Tab 1</Tag3TabHeader>
  <Tag3TabHeader name='tab2'>Tab 2</Tag3TabHeader>
  <Tag3TabHeader name='tab3'>Tab 3</Tag3TabHeader>
</Tag3TabHeaders>`,
    knobs: OldSchoolTabsStoryKnobs,
  },
};

const TabBadgesStory: Story = {
  title: 'Tab badges',
  description: 'Old school tabs with badges',
  coreComponent: {
    html: `<tag-tab-headers type='block'>
  <tag-tab-header name='quotes'>
    Enquiries
    <div style='margin-left: auto;'>
      <tag-badge value='5' size='small' accent='access' badge-style='{"border-radius": "0px"}'></tag-badge>
    </div>
  </tag-tab-header>
  <tag-tab-header name='calls'>
    Support calls
    <div style='margin-left: auto;'>
      <tag-badge value='3' size='small' accent='access' badge-style='{"border-radius": "0px"}'></tag-badge>
    </div>
  </tag-tab-header>
</tag-tab-headers>`,
  },
  coreComponent_v3: {
    html: `<tag3-tab-headers type='block'>
  <tag3-tab-header name='quotes'>
    Enquiries
    <div style='margin-left: auto;'>
      <tag3-badge value='5' size='small' accent='access' badge-style='{"border-radius": "0px"}'></tag3-badge>
    </div>
  </tag3-tab-header>
  <tag3-tab-header name='calls'>
    Support calls
    <div style='margin-left: auto;'>
      <tag3-badge value='3' size='small' accent='access' badge-style='{"border-radius": "0px"}'></tag3-badge>
    </div>
  </tag3-tab-header>
</tag3-tab-headers>`,
  },
  reactWrapper: {
    jsx: `<TagTabHeaders type='block'>
  <TagTabHeader name='quotes'>
    Enquiries
    <div style={{marginLeft: "auto"}}>
      <TagBadge value='5' size='small' accent='access' badgeStyle={{borderRadius: "0px"}}></TagBadge>
    </div>
  </TagTabHeader>
  <TagTabHeader name='calls'>
    Support calls
    <div style={{marginLeft: "auto"}}>
      <TagBadge value='3' size='small' accent='access' badgeStyle={{borderRadius: "0px"}}></TagBadge>
    </div>
  </TagTabHeader>
</TagTabHeaders>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3TabHeaders type='block'>
  <Tag3TabHeader name='quotes'>
    Enquiries
    <div style={{marginLeft: "auto"}}>
      <Tag3Badge value='5' size='small' accent='access' badgeStyle={{borderRadius: "0px"}}></Tag3Badge>
    </div>
  </Tag3TabHeader>
  <Tag3TabHeader name='calls'>
    Support calls
    <div style={{marginLeft: "auto"}}>
      <Tag3Badge value='3' size='small' accent='access' badgeStyle={{borderRadius: "0px"}}></Tag3Badge>
    </div>
  </Tag3TabHeader>
</Tag3TabHeaders>`,
  },
};

const TabContentHorizontalStory: Story = {
  title: 'Horizontal Tab content',
  description: 'Horizontal Tab headers with content',
  coreComponent: {
    html: `<tag-tab-headers>
  <tag-tab-header name='tab1'>Tab 1</tag-tab-header>
  <tag-tab-header name='tab2'>Tab 2</tag-tab-header>
  <tag-tab-header name='tab3'>Tab 3</tag-tab-header>
</tag-tab-headers>
<tag-tab-content name='tab1'><tag-text text="Tab 1 content"></tag-text></tag-tab-content>
<tag-tab-content name='tab2'><tag-text text="Tab 2 content"></tag-text></tag-tab-content>
<tag-tab-content name='tab3'><tag-text text="Tab 3 content"></tag-text></tag-tab-content>`,
  },
  coreComponent_v3: {
    html: `<tag3-tab-headers>
  <tag3-tab-header name='tab1'>Tab 1</tag3-tab-header>
  <tag3-tab-header name='tab2'>Tab 2</tag3-tab-header>
  <tag3-tab-header name='tab3'>Tab 3</tag3-tab-header>
</tag3-tab-headers>
<tag3-tab-content name='tab1'><tag3-p>Tab 1 content</tag3-p></tag3-tab-content>
<tag3-tab-content name='tab2'><tag3-p>Tab 2 content</tag3-p></tag3-tab-content>
<tag3-tab-content name='tab3'><tag3-p>Tab 3 content</tag3-p></tag3-tab-content>`,
  },
  reactWrapper: {
    jsx: `<React.Fragment>
  <TagTabHeaders>
    <TagTabHeader name='tab1'>Tab 1</TagTabHeader>
    <TagTabHeader name='tab2'>Tab 2</TagTabHeader>
    <TagTabHeader name='tab3'>Tab 3</TagTabHeader>
  </TagTabHeaders>
  <TagTabContent name='tab1'><TagText text="Tab 1 content" /></TagTabContent>
  <TagTabContent name='tab2'><TagText text="Tab 2 content" /></TagTabContent>
  <TagTabContent name='tab3'><TagText text="Tab 3 content" /></TagTabContent>
</React.Fragment>`,
  },
  reactWrapper_v3: {
    jsx: `<React.Fragment>
  <Tag3TabHeaders>
    <Tag3TabHeader name='tab1'>Tab 1</Tag3TabHeader>
    <Tag3TabHeader name='tab2'>Tab 2</Tag3TabHeader>
    <Tag3TabHeader name='tab3'>Tab 3</Tag3TabHeader>
  </Tag3TabHeaders>
  <Tag3TabContent name='tab1'><Tag3P>Tab 1 content</Tag3P></Tag3TabContent>
  <Tag3TabContent name='tab2'><Tag3P>Tab 2 content</Tag3P></Tag3TabContent>
  <Tag3TabContent name='tab3'><Tag3P>Tab 3 content</Tag3P></Tag3TabContent>
</React.Fragment>`,
  },
};

const VerticalContentHorizontalStory: Story = {
  title: 'Vertical Tab content',
  description: 'Vertical Tab headers with content',
  coreComponent: {
    html: `<div style='display:flex;'>
  <tag-tab-headers orientation='vertical' style='width:150px;'>
    <tag-tab-header name='tab1'>Tab 1</tag-tab-header>
    <tag-tab-header name='tab2'>Tab 2</tag-tab-header>
    <tag-tab-header name='tab3'>Tab 3</tag-tab-header>
  </tag-tab-headers>
  <div style='padding: 0px 15px;'>
    <tag-tab-content name='tab1'><tag-text text="Tab 1 content"></tag-text></tag-tab-content>
    <tag-tab-content name='tab2'><tag-text text="Tab 2 content"></tag-text></tag-tab-content>
    <tag-tab-content name='tab3'><tag-text text="Tab 3 content"></tag-text></tag-tab-content>
  </div>
</div>`,
  },
  coreComponent_v3: {
    html: `<div style='display:flex;'>
  <tag3-tab-headers orientation='vertical' style='width:150px;'>
    <tag3-tab-header name='tab1'>Tab 1</tag3-tab-header>
    <tag3-tab-header name='tab2'>Tab 2</tag3-tab-header>
    <tag3-tab-header name='tab3'>Tab 3</tag3-tab-header>
  </tag3-tab-headers>
  <div style='padding: 0px 15px;'>
    <tag3-tab-content name='tab1'><tag3-p>Tab 1 content</tag3-p></tag3-tab-content>
    <tag3-tab-content name='tab2'><tag3-p>Tab 2 content</tag3-p></tag3-tab-content>
    <tag3-tab-content name='tab3'><tag3-p>Tab 3 content</tag3-p></tag3-tab-content>
  </div>
</div>`,
  },
  reactWrapper: {
    jsx: `<div style={{display: "flex"}}>
  <TagTabHeaders orientation='vertical' style={{width: "150px"}}>
    <TagTabHeader name='tab1'>Tab 1</TagTabHeader>
    <TagTabHeader name='tab2'>Tab 2</TagTabHeader>
    <TagTabHeader name='tab3'>Tab 3</TagTabHeader>
  </TagTabHeaders>
  <div style={{padding: "0px 15px"}}>
    <TagTabContent name='tab1'><TagText text="Tab 1 content" /></TagTabContent>
    <TagTabContent name='tab2'><TagText text="Tab 2 content" /></TagTabContent>
    <TagTabContent name='tab3'><TagText text="Tab 3 content" /></TagTabContent>
  </div>
</div>`,
  },
  reactWrapper_v3: {
    jsx: `<div style={{display: "flex"}}>
  <Tag3TabHeaders orientation='vertical' style={{width: "150px"}}>
    <Tag3TabHeader name='tab1'>Tab 1</Tag3TabHeader>
    <Tag3TabHeader name='tab2'>Tab 2</Tag3TabHeader>
    <Tag3TabHeader name='tab3'>Tab 3</Tag3TabHeader>
  </Tag3TabHeaders>
  <div style={{padding: "0px 15px"}}>
    <Tag3TabContent name='tab1'><Tag3P>Tab 1 content</Tag3P></Tag3TabContent>
    <Tag3TabContent name='tab2'><Tag3P>Tab 2 content</Tag3P></Tag3TabContent>
    <Tag3TabContent name='tab3'><Tag3P>Tab 3 content</Tag3P></Tag3TabContent>
  </div>
</div>`,
  },
};

const OnDemandStory: Story = {
  title: 'On demand',
  description: 'Tab content that is only rendered when the tab is selected',
  coreComponent: {
    html: `<tag-tab-headers data-name="demo" selected-tab="tab1">
  <tag-tab-header name="tab1">Tab 1</tag-tab-header>
  <tag-tab-header name="tab2">Tab 2</tag-tab-header>
  <tag-tab-header name="tab3">Tab 3</tag-tab-header>
</tag-tab-headers>
<tag-tab-content data-name="demo" container-style='{"font-size": "14px", "padding": "10px 0px"}'>
  <span>Content for tab 1</span>
</tag-tab-content>`,
    js: `var tabs = document.querySelector('tag-tab-headers[data-name="demo"]');
tabs.componentOnReady().then(function() {
  tabs.addEventListener('tabHeaderChange', function(e) {
    var span = document.querySelector('tag-tab-content[data-name="demo"] span');
    span.textContent =
      'Content for ' + e.detail.name + ' rendered at ' + new Date().toLocaleTimeString();
  });
});`,
  },
  coreComponent_v3: {
    html: `<tag3-tab-headers data-name="demo" selected-tab="tab1">
  <tag3-tab-header name="tab1">Tab 1</tag3-tab-header>
  <tag3-tab-header name="tab2">Tab 2</tag3-tab-header>
  <tag3-tab-header name="tab3">Tab 3</tag3-tab-header>
</tag3-tab-headers>
<tag3-tab-content data-name="demo" container-style='{"font-size": "14px", "padding": "10px 0px"}'>
  <span>Content for tab 1</span>
</tag3tab-content>`,
    js: `var tabs = document.querySelector('tag3-tab-headers[data-name="demo"]');
tabs.addEventListener('tabHeaderChange', function(e) {
  var span = document.querySelector('tag3-tab-content[data-name="demo"] span');
  span.textContent =
    'Content for ' + e.detail.name + ' rendered at ' + new Date().toLocaleTimeString();
});`,
  },
  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [selectedTab, setSelectedTab] = React.useState('tab1');
    const renderTab = tab => <span>Content for {tab} rendered at {new Date().toLocaleTimeString()}</span>
    return (
      <React.Fragment>
        <TagTabHeaders
          selectedTab={selectedTab}
          onTabHeaderChange={e => setSelectedTab(e.detail.name)}>
          <TagTabHeader name='tab1'>Tab 1</TagTabHeader>
          <TagTabHeader name='tab2'>Tab 2</TagTabHeader>
          <TagTabHeader name='tab3'>Tab 3</TagTabHeader>
        </TagTabHeaders>
        <TagTabContent containerStyle={{fontSize: "14px", padding: "10px 0px"}}>{renderTab(selectedTab)}</TagTabContent>
      </React.Fragment>
    )
  }`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [selectedTab, setSelectedTab] = React.useState('tab1');
    const renderTab = tab => <span>Content for {tab} rendered at {new Date().toLocaleTimeString()}</span>
    return (
      <React.Fragment>
        <Tag3TabHeaders
          selectedTab={selectedTab}
          onTabHeaderChange={e => setSelectedTab(e.detail.name)}>
          <Tag3TabHeader name='tab1'>Tab 1</Tag3TabHeader>
          <Tag3TabHeader name='tab2'>Tab 2</Tag3TabHeader>
          <Tag3TabHeader name='tab3'>Tab 3</Tag3TabHeader>
        </Tag3TabHeaders>
        <Tag3TabContent containerStyle={{fontSize: "14px", padding: "10px 0px"}}>{renderTab(selectedTab)}</Tag3TabContent>
      </React.Fragment>
    )
  }`,
  },
};

const TabsWithinTabsStory: Story = {
  title: 'Tabs within tabs',
  description: 'Horizontal tabs within vertical tabs',
  coreComponent: {
    html: `<div style="display: flex;">
  <tag-tab-headers orientation="vertical" style='width:150px;' selected-tab="tab1">
    <tag-tab-header name="tab1">Tab 1</tag-tab-header>
    <tag-tab-header name="tab2">Tab 2</tag-tab-header>
  </tag-tab-headers>
  <tag-tab-content name="tab1">
    <div style="padding: 0px 25px;">
      <tag-tab-headers orientation="horizontal" selected-tab="tabA">
        <tag-tab-header name="tabA" caption='Tab A'>Tab A</tag-tab-header>
        <tag-tab-header name="tabB" caption='Tab B'>Tab B</tag-tab-header>
        <tag-tab-header name="tabC" caption='Tab C'>Tab C</tag-tab-header>
      </tag-tab-headers>
      <tag-tab-content name="tabA">
        <tag-text text="Tab 1 + Tab A"></tag-text>
      </tag-tab-content>
      <tag-tab-content name="tabB">
        <tag-text text="Tab 1 + Tab B"></tag-text>
      </tag-tab-content>
      <tag-tab-content name="tabC">
        <tag-text text="Tab 1 + Tab C"></tag-text>
      </tag-tab-content>
    </div>
  </tag-tab-content>
  <tag-tab-content name="tab2">
    <div style="padding: 0px 25px;">
      <tag-tab-headers orientation="horizontal" selected-tab="tabD">
        <tag-tab-header name="tabD" caption='Tab D'>Tab D</tag-tab-header>
        <tag-tab-header name="tabE" caption='Tab E'>Tab E</tag-tab-header>
        <tag-tab-header name="tabF" caption='Tab F'>Tab F</tag-tab-header>
      </tag-tab-headers>
      <tag-tab-content name="tabD">
        <tag-text text="Tab 2 + Tab D"></tag-text>
      </tag-tab-content>
      <tag-tab-content name="tabE">
        <tag-text text="Tab 2 + Tab E"></tag-text>
      </tag-tab-content>
      <tag-tab-content name="tabF">
        <tag-text text="Tab 2 + Tab F"></tag-text>
      </tag-tab-content>
    </div>
  </tag-tab-content>
</div>`,
  },
  coreComponent_v3: {
    html: `<div style="display: flex;">
  <tag3-tab-headers orientation="vertical" style='width:150px;' selected-tab="tab1">
    <tag3-tab-header name="tab1">Tab 1</tag3-tab-header>
    <tag3-tab-header name="tab2">Tab 2</tag3-tab-header>
  </tag3-tab-headers>
  <tag3-tab-content name="tab1">
    <div style="padding: 0px 25px;">
      <tag3-tab-headers orientation="horizontal" selected-tab="tabA">
        <tag3-tab-header name="tabA" caption='Tab A'>Tab A</tag3-tab-header>
        <tag3-tab-header name="tabB" caption='Tab B'>Tab B</tag3-tab-header>
        <tag3-tab-header name="tabC" caption='Tab C'>Tab C</tag3-tab-header>
      </tag3-tab-headers>
      <tag3-tab-content name="tabA">
        <tag3-text text="Tab 1 + Tab A"></tag3-text>
      </tag3-tab-content>
      <tag3-tab-content name="tabB">
        <tag3-text text="Tab 1 + Tab B"></tag3-text>
      </tag3-tab-content>
      <tag3-tab-content name="tabC">
        <tag3-text text="Tab 1 + Tab C"></tag3-text>
      </tag3-tab-content>
    </div>
  </tag3-tab-content>
  <tag3-tab-content name="tab2">
    <div style="padding: 0px 25px;">
      <tag3-tab-headers orientation="horizontal" selected-tab="tabD">
        <tag3-tab-header name="tabD" caption='Tab D'>Tab D</tag3-tab-header>
        <tag3-tab-header name="tabE" caption='Tab E'>Tab E</tag3-tab-header>
        <tag3-tab-header name="tabF" caption='Tab F'>Tab F</tag3-tab-header>
      </tag3-tab-headers>
      <tag3-tab-content name="tabD">
        <tag3-text text="Tab 2 + Tab D"></tag3-text>
      </tag3-tab-content>
      <tag3-tab-content name="tabE">
        <tag3-text text="Tab 2 + Tab E"></tag3-text>
      </tag3-tab-content>
      <tag3-tab-content name="tabF">
        <tag3-text text="Tab 2 + Tab F"></tag3-text>
      </tag3-tab-content>
    </div>
  </tag3-tab-content>
</div>`,
  },
  reactWrapper: {
    jsx: `<div style={{display: "flex"}}>
  <TagTabHeaders orientation="vertical" style={{width:"150px"}}  selectedTab="tab1">
    <TagTabHeader name="tab1">Tab 1</TagTabHeader>
    <TagTabHeader name="tab2">Tab 2</TagTabHeader>
  </TagTabHeaders>
  <TagTabContent name="tab1">
    <div style={{padding: "0px 25px"}}>
      <TagTabHeaders orientation="horizontal"  selectedTab="tabA">
        <TagTabHeader name="tabA" caption='Tab A'>Tab A</TagTabHeader>
        <TagTabHeader name="tabB" caption='Tab B'>Tab B</TagTabHeader>
        <TagTabHeader name="tabC" caption='Tab C'>Tab C</TagTabHeader>
      </TagTabHeaders>
      <TagTabContent name="tabA">
        <tag-text text="Tab 1 + Tab A"></tag-text>
      </TagTabContent>
      <TagTabContent name="tabB">
        <tag-text text="Tab 1 + Tab B"></tag-text>
      </TagTabContent>
      <TagTabContent name="tabC">
        <tag-text text="Tab 1 + Tab C"></tag-text>
      </TagTabContent>
    </div>
  </TagTabContent>
  <TagTabContent name="tab2">
    <div style={{padding: "0px 25px"}}>
      <TagTabHeaders orientation="horizontal"  selectedTab="tabD">
        <TagTabHeader name="tabD" caption='Tab D'>Tab D</TagTabHeader>
        <TagTabHeader name="tabE" caption='Tab E'>Tab E</TagTabHeader>
        <TagTabHeader name="tabF" caption='Tab F'>Tab F</TagTabHeader>
      </TagTabHeaders>
      <TagTabContent name="tabD">
        <tag-text text="Tab 2 + Tab D"></tag-text>
      </TagTabContent>
      <TagTabContent name="tabE">
        <tag-text text="Tab 2 + Tab E"></tag-text>
      </TagTabContent>
      <TagTabContent name="tabF">
        <tag-text text="Tab 2 + Tab F"></tag-text>
      </TagTabContent>
    </div>
  </TagTabContent>
</div>`,
  },
  reactWrapper_v3: {
    jsx: `<div style={{display: "flex"}}>
  <Tag3TabHeaders orientation="vertical" style={{width:"150px"}}  selectedTab="tab1">
    <Tag3TabHeader name="tab1">Tab 1</Tag3TabHeader>
    <Tag3TabHeader name="tab2">Tab 2</Tag3TabHeader>
  </Tag3TabHeaders>
  <Tag3TabContent name="tab1">
    <div style={{padding: "0px 25px"}}>
      <Tag3TabHeaders orientation="horizontal"  selectedTab="tabA">
        <Tag3TabHeader name="tabA">Tab A</Tag3TabHeader>
        <Tag3TabHeader name="tabB">Tab B</Tag3TabHeader>
        <Tag3TabHeader name="tabC">Tab C</Tag3TabHeader>
      </Tag3TabHeaders>
      <Tag3TabContent name="tabA">
        <Tag3Text text="Tab 1 + Tab A"></Tag3Text>
      </Tag3TabContent>
      <Tag3TabContent name="tabB">
        <Tag3Text text="Tab 1 + Tab B"></Tag3Text>
      </Tag3TabContent>
      <Tag3TabContent name="tabC">
        <Tag3Text text="Tab 1 + Tab C"></Tag3Text>
      </Tag3TabContent>
    </div>
  </Tag3TabContent>
  <Tag3TabContent name="tab2">
    <div style={{padding: "0px 25px"}}>
      <Tag3TabHeaders orientation="horizontal" selectedTab="tabD">
        <Tag3TabHeader name="tabD">Tab D</Tag3TabHeader>
        <Tag3TabHeader name="tabE">Tab E</Tag3TabHeader>
        <Tag3TabHeader name="tabF">Tab F</Tag3TabHeader>
      </Tag3TabHeaders>
      <Tag3TabContent name="tabD">
        <Tag3Text text="Tab 2 + Tab D"></Tag3Text>
      </Tag3TabContent>
      <Tag3TabContent name="tabE">
        <Tag3Text text="Tab 2 + Tab E"></Tag3Text>
      </Tag3TabContent>
      <Tag3TabContent name="tabF">
        <Tag3Text text="Tab 2 + Tab F"></Tag3Text>
      </Tag3TabContent>
    </div>
  </Tag3TabContent>
</div>`,
  },
};

export const TagTabHeaderDocs: Component = {
  type: 'component',
  name: 'tab-header',
  description: 'Renders a tab header',
  mobileFriendly: true,
  popular: true,
  preRelease: '',
  props: [
    {
      name: 'name',
      default: '',
      description: 'A unique name for the tab',
      type: 'string',
    },
    {
      name: 'invisible',
      default: 'false',
      description: 'Whether the tab is invisible',
      type: 'boolean',
    },
    {
      name: 'disabled',
      default: 'false',
      description: 'Whether the tab is disabled',
      type: 'boolean',
    },
    {
      name: 'containerStyle',
      description: 'The CSS JSON style for the container',
      type: 'string',
    },
    {
      name: 'selectedContainerStyle',
      description: 'The CSS JSON style for the container when the tab is selected',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'tabHeaderChange',
      description: 'Event raised when the selected tab changes',
      parameters: [
        {
          name: 'name',
          description: 'The tab name',
          type: 'string',
        },
      ],
    },
  ],
  methods: [],
  stories: [],
};

export const TagTabContentDocs: Component = {
  type: 'component',
  name: 'tab-content',
  description: 'Renders a tabs content',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      default: '',
      description: 'The name of the tab to render content for. Should match tag-tab-header.name',
      type: 'string',
    },
    {
      name: 'containerStyle',
      description: 'The CSS JSON style for the container',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [],
};

export const TagTabHeadersDocs: Component = {
  type: 'component',
  name: 'tab-headers',
  description: 'Renders a set of tab headers',
  mobileFriendly: true,
  popular: true,
  preRelease: '',
  props: [
    {
      name: 'type',
      default: 'underline',
      description: 'v3 only: The style of tabs',
      type: 'underline | block | pills',
    },
    {
      name: 'accent',
      default: 'viridiangreen',
      description: 'The selected tab accent colour',
      type: 'string',
    },
    {
      name: 'orientation',
      default: 'horizontal',
      description: 'The orientation of tabs',
      type: 'horizontal | vertical',
    },
    {
      name: 'size',
      default: 'default',
      description: 'The size of tabs',
      type: 'default | small | large',
    },
    {
      name: 'selectedTab',
      default: '',
      description: 'The name of the selected tab',
      type: 'string',
    },
    {
      name: 'containerStyle',
      description: 'The CSS JSON style for the container',
      type: 'string',
    },
    {
      name: 'colourScheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'tabHeaderChange',
      description: 'Event raised when the selected tab changes',
      parameters: [
        {
          name: 'name',
          description: 'The tab name',
          type: 'string',
        },
      ],
    },
  ],
  methods: [],
  stories: [
    PlaygroundStory,
    SelectedTabStory,
    InvisibleTabStory,
    DisabledTabStory,
    TabIconsStory,
    ControlledSelectedTabStory,
    OldSchoolTabsStory,
    TabBadgesStory,
    TabContentHorizontalStory,
    VerticalContentHorizontalStory,
    OnDemandStory,
    TabsWithinTabsStory,
  ],
  childComponents: [TagTabHeaderDocs, TagTabContentDocs],
};
